import React from 'react';
import HeroSection from '../components/landing/HeroSection';
import FeatureSection from '../components/landing/FeatureSection';
import HowItWorks from '../components/landing/HowItWorks';
import PreviewSection from '../components/landing/PreviewSection';
import CTASection from '../components/landing/CTASection';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <FeatureSection />
      <HowItWorks />
      <PreviewSection />
      <CTASection />
    </div>
  );
};

export default LandingPage;